import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import { map, capitalize, add } from "lodash";
//import Lead from "./Lead";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage, FieldArray } from "formik";
import * as Yup from "yup";
import Moment from 'react-moment';
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { addClientAddListing, getAddHomePref, getClientAddListing, deleteHomePref, getClientDetail, getListingType, getUserDetail, postHomePref, getHomePref, updateHomePref, createAddHomePref, updateAddHomePref, postImpDestination, getImpDestination, updateImpDestination, deleteImpDestination } from "../../store/actions"
import CurrencyFormat from 'react-currency-format';
import Switch from "react-switch"
import typeView from "../../assets/images/type-view.png"
import uploadView from "../../assets/images/icons/upload.png"
import gridView from "../../assets/images/grid-view.png"
import downloadView from "../../assets/images/icons/down.png"
import compareImg from "../../assets/img/compare-new.png"
import viewRouteImg from "../../assets/img/route-new.png"
import houseIcon from "../../assets/img/house-icon.png"
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import Dropzone from "react-dropzone"
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table"
import classnames from "classnames"
import img1 from "../../assets/img/img1.jpg"
import img2 from "../../assets/img/img2.jpg"
import img3 from "../../assets/img/img3.jpg"
import deleteIcon from "../../assets/images/icons/bin.png";
import impDates from "../../pages/Prefrences/important-destinations";
import CurrencyInput from "react-currency-input-field";
import Swal from "sweetalert2";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import hGreenIcon from "../../assets/img/heart-green.png";
import hRedIcon from "../../assets/img/heart-red.png";
import messageIcon from "../../assets/img/message-icon-new.png"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormGroup,
  Label,
  Input,
  Button,
  InputGroup,
  Tooltip,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Dropdown,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Collapse,
  CardHeader,
  Alert
} from "reactstrap"
import { API_URL } from "helpers/api_url";
import axios from "axios";
import moment from "moment";
import { BlobServiceClient } from '@azure/storage-blob';
import { azureConfig } from "../../helpers/azureConfig";
import RsLink from "components/Buttons/rsLink";
import { use } from "react";
import AiButton from "components/Buttons/aiBtn";
import DeleteModal from "components/Common/DeleteModal";
import TimePicker from "components/Common/Timepicker";
import EngagementListBuyerClient from "components/dropdowns/EngagementListBuyerClient";
class addListing extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeTab1: "1",
      open: false,
      selectedFiles: [],
      selectedListings: [],
      mlsFields: [{ mlsId: "", mlsLink: "", mlsCity: "", mlsNote: "", mlsPrice: "" }],
      agentId: localStorage.getItem("agentId"),
      clientId: localStorage.getItem("userId"),
      forDate: "",
      routeData: [],
      searchQuery: '',
      listingType: '0',
      listingStatus: '0',
      filteredListings: [],
      activeTab3: "1",
      homeprefrence: '',
      addprefrence: '',
      lightboxOpen: false,
      photoIndex: 0,
    }
    this.toggle = this.toggle.bind(this);
    this.handleAddListingSubmit = this.handleAddListingSubmit.bind(this);
    this.toggleRightCanvas = this.toggleRightCanvas.bind(this);
    this.toggle1 = this.toggle1.bind(this);
    this.toggleCreateRoute = this.toggleCreateRoute.bind(this);
    this.handleSubmitMessage = this.handleSubmitMessage.bind(this);
    this.handleSubmitResuchedule = this.handleSubmitResuchedule.bind(this);
    this.handleChangeStatus = this.handleChangeStatus.bind(this);
    this.t_col1 = this.t_col1.bind(this);
    this.t_col2 = this.t_col2.bind(this);
    this.t_col3 = this.t_col3.bind(this);
    this.toggle3 = this.toggle3.bind(this);
    this.handleHomePrefSubmit = this.handleHomePrefSubmit.bind(this);
    this.togglePrefrences = this.togglePrefrences.bind(this);
    this.submitAddHomePrefData = this.submitAddHomePrefData.bind(this);
    this.onClickDelete = this.onClickDelete.bind(this);
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
    this.onClickDeleteDates = this.onClickDeleteDates.bind(this);
    this.handelFavSubmit = this.handelFavSubmit.bind(this);
    this.toggleViewFav = this.toggleViewFav.bind(this);

  }
  handleOpenLightbox = (index) => {
    this.setState({ lightboxOpen: true, photoIndex: index });
  };
  toggleDeleteModal = () => {
    this.setState(prevState => ({
      deleteModal: !prevState.deleteModal,
    }));
  };
  onClickDeleteDates = (impdestination) => {
    this.setState({ impdestination: impdestination });
    this.setState({ deleteModal: true });
  };
  handleDelete = () => {
    const { onDelete } = this.props;
    const { impdestination } = this.state;
    if (impdestination.id !== undefined) {
      onDelete(impdestination);
      this.setState({ deleteModal: false });
    }
  };
  handleValidSubmit = (value, actions) => {
    this.props.postImpDestination(value, (status)=>{
        if(status==true){
          actions.resetForm();
        }
    });
  }
  onClickDelete = (homeprefrence) => {
    this.setState({ homeprefrence: homeprefrence });
    this.setState({ deleteModal: true });
  };
  handleDeleteHomePref = () => {
    const { onDeleteHomePref } = this.props;
    const { homeprefrence } = this.state;
    if (homeprefrence.id !== undefined) {
      onDeleteHomePref(homeprefrence);
      this.setState({ deleteModal: false });
    }
  };
  toggle3(tab) {
    if (this.state.activeTab3 !== tab) {
      this.setState({
        activeTab3: tab,
      });
    }
  }
  handleInputChange = (e) => {
    this.setState({ searchQuery: e.target.value }, this.filterListings);
  };
  handleListingTypeChange = (e) => {
    this.setState({ listingType: e.target.value }, this.filterListings);
  };
  handleStatusChange = (e) => {
    this.setState({ listingStatus: e.target.value }, this.filterListings);
  };
  filterListings = () => {
    const { searchQuery, listingType, listingStatus } = this.state;
    const { addListings } = this.props;
    const today = new Date();
    const filtered = addListings.filter((listing) => {
      const matchesSearch =
        listing.mlsId.toLowerCase().includes(searchQuery.toLowerCase()) ||
        listing.listingCity.toLowerCase().includes(searchQuery.toLowerCase());
      let matchesType = false;
      switch (listingType) {
        case '0':
          matchesType = true;
          break;
        case '1':
          matchesType = listing.addedBy === 'agent';
          break;
        case '2':
          matchesType = listing.addedBy === 'client';
          break;
        case '3':
          matchesType = listing.showingStatusId === 1;
          break;
        case '4': {
          const showingDate = new Date(listing.showingDate);
          matchesType = listing.showingStatusId === 1 && showingDate > today;
          break;
        }
        case '5':
          matchesType = listing.showingStatusId !== 1;
          break;
        case '6':
          matchesType = listing.isInterested === true;
          break;
        case '7':
          matchesType = listing.isInterested === false;
          break;
         case '8':
          matchesType = listing.isFavourite === true;
          break;
        default:
          matchesType = true;
      }
      // const matchesType =
      // listingType === '0' ||
      // (listingType === '1' && listing.addedBy === 'agent') ||
      // (listingType === '2' && listing.addedBy === 'client') ||
      // (listingType === '3' && listing.showingStatusId === 1 )
      const matchesStatus =
        listingStatus === '0' || String(listing.listingStatusId) === listingStatus;
      return matchesSearch && matchesType && matchesStatus;
    });
    this.setState({ filteredListings: filtered });
  };
  t_col1() {
    this.setState({
      col1: !this.state.col1,
      col2: false,
      col3: false,
    });
  }
  t_col2() {
    this.setState({
      col1: false,
      col2: !this.state.col2,
      col3: false,
    });
  }
  t_col3() {
    this.setState({
      col1: false,
      col2: false,
      col3: !this.state.col3,
    });
  }
  handleCheckboxChange = (listingId, event) => {
    const { selectedListings } = this.state;
    if (event.target.checked) {
      this.setState({ selectedListings: [...selectedListings, listingId] });
    } else {
      this.setState({ selectedListings: selectedListings.filter(id => id !== listingId) });
    }
  };
  handleAcceptedFiles = async (acceptedFiles) => {
    const filesWithPreview = acceptedFiles.map(file => {
      file.preview = URL.createObjectURL(file);
      file.formattedSize = this.formatBytes(file.size);
      return file;
    });
    this.setState({ selectedFiles: filesWithPreview });
    filesWithPreview.forEach(file => this.uploadFileToAzure(file));
  };
  uploadFileToAzure = async (file) => {
    const maxSize = 2 * 1024 * 1024; // 5 MB
    const allowedTypes = ['image/jpeg', 'image/png'];
    const allowedExtensions = ['.jpg', '.jpeg', '.png'];
    const fileExtension = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();
    // Validate file type
    if (!allowedTypes.includes(file.type) || !allowedExtensions.includes(fileExtension)) {
      Swal.fire({
        title: 'File type or extension not allowed',
        text: 'Please upload a JPG, or PNG file.',
        icon: 'warning',
        confirmButtonText: 'OK',
      });
      return;
    }
    // Validate file size
    if (file.size > maxSize) {
      Swal.fire({
        title: 'File size exceeded',
        text: 'Please upload a file smaller than 2MB.',
        icon: 'warning',
        confirmButtonText: 'OK',
      });
      return;
    }
    const sasToken = azureConfig.sasToken
    const containerName = azureConfig.containerName;
    const accountName = azureConfig.storageAccountName;
    const blobServiceClient = new BlobServiceClient(
      `https://${accountName}.blob.core.windows.net?${sasToken}`
    );
    const fileName = `${Date.now()}_${file.name}`;
    const containerClient = blobServiceClient.getContainerClient(containerName);
    const blockBlobClient = containerClient.getBlockBlobClient(fileName);
    try {
      toast.loading('please wait...');
      await blockBlobClient.uploadBrowserData(file);
      const fileUrl = `https://${accountName}.blob.core.windows.net/${containerName}/${fileName}`;
      const payload = {
        "clientShowingId": this.state.addListing?.id,
        "clientPotentialListingImageTitle": fileName,
        "clientPotentialListingImageLink": fileUrl,
        "clientPotentialListingImageTypeId": 0,
        "clientPotentialListingImageStorageType": 0,
        "agentId": parseInt(localStorage.getItem('agentId')),
        "clientId" : parseInt(localStorage.getItem('userId')),
        "isActive": true
      }
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;
      const apiUrl = `${API_URL}ClientPotentialListingImage`
      const method = "post";
      const response = await axios({
        method,
        url: apiUrl,
        data: payload,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200 || response.status === 201) {
        toast.dismiss();
        toast.success("Images uploaded successfully")
        this.fetchImages(this.state.addListing?.id);
      }
    } catch (error) {
      console.error('Error uploading file to Azure Blob Storage', error);
    }
  };
  fetchImages(listingId) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    const params = {
      ClientId: localStorage.getItem('userId'),
      ShowingId: listingId,
      agentId: localStorage.getItem('agentId')
    }
    axios
      .get(`${API_URL}ClientPotentialListingImage/allbyshowing/`, { headers, params })
      .then((response) => {
        this.setState({ imagesData: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }
  handleDeleteImage = (imageId, index) => {
    console.log("Deleting Image ID:", imageId);
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    Swal.fire({
      title: "Are you sure?",
      text: "This image will be deleted permanently!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`${API_URL}ClientPotentialListingImage/${imageId}`, { headers })
          .then((response) => {
            console.log("Delete Response:", response);
            if (response.status === 200 || response.status === 204) {
              Swal.fire("Deleted!", "Your image has been deleted.", "success");
              const updatedImages = [...this.state.imagesData];
              updatedImages.splice(index, 1);
              this.setState({ imagesData: updatedImages });
            } else {
              Swal.fire("Error!", "Failed to delete image!", "error");
            }
          })
          .catch((error) => {
            console.error("Delete Error:", error);
            Swal.fire("Error!", "Something went wrong!", "error");
          });
      }
    });
  };
  formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  };
  handleSubmitResuchedule = async (values, { setSubmitting, resetForm }) => {
    try {
      toast.loading("please wait...");
      const payload = {
        id: values.id,
        clientPotentialListingId: values.clientPotentialListingId,
        clientId: parseInt(values.clientId),
        agentId: parseInt(values.agentId),
        notes: values.notes,
        showingDate: moment(values.showingDate).format("YYYY-MM-DD"),
        startTime: values.startTime,
        endTime: values.endTime,
        showingStatus: "Request Re-schedule",
        showingStatusId: 2,
        clientNotes: values.clientNotes
      }
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;
      const apiUrl = `${API_URL}ClientPotentialListing/ReScheduleRequestClientPotentialListingShowing`
      const method = "put";
      const response = await axios({
        method,
        url: apiUrl,
        data: payload,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200 || response.status === 201) {
        toast.dismiss();
        toast.success("Saved successfully")
        this.manageToggle();
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    } finally {
      setSubmitting(false);
    }
  }
  handleSubmitMessage = async (values, { setSubmitting, resetForm }) => {
    try {
      toast.loading("please wait...");
      const payload = {
        clientPotentialListingMessageBy: values.clientPotentialListingMessageBy,
        clientPotentialListingId: parseInt(values.clientPotentialListingId),
        scheduleDate: moment(values.scheduleDate).format("YYYY-MM-DD"),
        notes: values.notes,
        agentId: parseInt(localStorage.getItem('agentId')),
        clientId: parseInt(localStorage.getItem('userId'))
      }
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;
      const apiUrl = `${API_URL}ClientPotentialListingMessage`
      const method = "post";
      const response = await axios({
        method,
        url: apiUrl,
        data: payload,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200 || response.status === 201) {
        toast.dismiss();
        toast.success("Saved successfully")
        this.fetchMessage(values.clientPotentialListingId);
        this.manageToggle();
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    } finally {
      setSubmitting(false);
    }
  }
  fetchMessage(listingId) {
     const agentId = localStorage.getItem('agentId');
     const clientId = localStorage.getItem('userId');
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    axios
      .get(`${API_URL}ClientPotentialListingMessage/${listingId}?clientId=${clientId}&agentId=${agentId}`, { headers })
      .then((response) => {
        this.setState({ messageData: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }
  updateMessage(listingId) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    const payload = {
      clientPotentialListingId: listingId,
      agentId: parseInt(localStorage.getItem('agentId')),
      clientId: parseInt(localStorage.getItem('userId'))
    }
    axios
      .post(`${API_URL}ClientPotentialListingMessage/ClearClientPotentialListingMessageNewFlag`, payload, { headers })
      .then((response) => {
        const { onGetClientAddListing, } = this.props;
        onGetClientAddListing(localStorage.getItem('userId'), localStorage.getItem('agentId'));
      })
      .catch((error) => {
      });
  }
  manageToggle() {
    this.setState(prevState => ({
      isRight: !prevState.isRight,
      activeTab1: !prevState.isRight ? "1" : prevState.activeTab1,
    }));
  }
  toggleRightCanvas() {
    this.setState({ addListing: '', isEdit: false, isRight: !this.state.isRight });
    this.manageToggle();
  }
  toggleRightCanvas = arg => {
    const addListing = arg;
    // console.log(addListing);
    this.setState({
      addListing: {
        id: addListing.id,
        clientPotentialListingId: addListing.clientPotentialListingId,
        clientId: addListing.clientId,
        agentId: addListing.agentId,
        mlsId: addListing.mlsId,
        mlsurl: addListing.mlsurl,
        listingDate: addListing.listingDate,
        listingStatusId: addListing.listingStatusId,
        isInterested: addListing.isInterested,
        isActive: addListing.isActive,
        addedBy: addListing.addedBy,
        listedPrice: addListing.listedPrice,
        listingType: addListing.listingType,
        listingBathroom: addListing.listingBathroom,
        listingBedroom: addListing.listingBedroom,
        listingParking: addListing.listingParking,
        listingAddress: addListing.listingAddress,
        listingCity: addListing.listingCity,
        notes: addListing.notes,
        showingDate: addListing.showingDate,
        startTime: addListing.startTime,
        endTime: addListing.endTime,
        showingStatus: addListing.showingStatus,
        showingStatusId: addListing.showingStatusId,
        clientNotes: addListing.clientNotes,
        likeDislike: addListing.likeDislike,
        statusId: addListing.statusId,
        anyAcceptedOffer: addListing.anyAcceptedOffer,
        feedback: addListing.feedback,
        addedByTypeId: addListing.addedByTypeId,
        transactionStatus: addListing.transactionStatus,
        listingSqFt: addListing.listingSqFt
      },
      isEdit: true
    });
    this.fetchMessage(addListing.id);
    this.updateMessage(addListing.id);
    this.fetchImages(addListing.id);
    this.fetchListingShowingHistory(addListing.id);
    this.fetchAnswerWithStandard(addListing.id, this.props.clientDetail?.clientId);
    this.manageToggle();
  }
  toggle() {
    this.setState({
      open: !this.state.open
    })
  }
  handleAddListingSubmit = (values, actions) => {
    values.createClientPotentialListingLists.forEach(listing => {
      const payload = {
        clientId: parseInt(listing.clientId),
        agentId: parseInt(listing.agentId),
        engagementId: parseInt(listing.engagementId),
        mlsId: listing.mlsId,
        mlsurl: listing.mlsurl,
        listingDate: listing.listingDate,
        listingStatusId: 0,
        isInterested: listing.isInterested,
        isActive: listing.isActive,
        addedBy: listing.addedBy,
        listedPrice: listing.listedPrice ? parseInt(listing.listedPrice) : 0,
        listingType: listing.listingType ? parseInt(listing.listingType) : 0,
        listingBedroom: listing.listingBedroom,
        listingBathroom: listing.listingBathroom,
        listingParking: listing.listingParking ? parseInt(listing.listingParking) : 0,
        listingAddress: listing.listingAddress,
        listingCity: listing.listingCity,
        listingSqFt: listing.listingSqFt,
        notes: listing.notes,
        addedBy: "client",
        statusId: 0
      };
      this.props.addClientAddListing(payload, (status) => {
        if (status == true) {
          actions.resetForm();
        }
      })
    });
  }
  getStatus = (status) => {
    if (status == 1)
      return 'Available';
    else if (status == 2)
      return 'Not Available';
    else if (status == 3)
      return 'Sold';
    else if (status == 4)
      return 'Sold Conditionally'
  }
  componentDidMount() {
    const { onGetClientAddListing, onGetListingType, onGetAddHomePref, onGetClientDetail, onGetUserDetail, onGetHomePref, onGetImpDestination } = this.props;
    onGetClientDetail(localStorage.getItem('userId'));
    onGetClientAddListing(localStorage.getItem('userId'), localStorage.getItem('agentId'))
    onGetUserDetail(localStorage.getItem('agentId'));
    onGetImpDestination(localStorage.getItem('agentId'), localStorage.getItem('userId'));
    onGetListingType(3)
    if (this.props.clientDetail?.clientId) {
      onGetAddHomePref(this.props.clientDetail.clientId);
      onGetHomePref(this.props.clientDetail.clientId);
    }
    this.fetchRouteData();
    this.filterListings();
  }
  componentDidUpdate(prevProps, prevState) {
    const { clientDetail, onGetAddHomePref } = this.props;
    if (prevProps.clientDetail?.clientId !== clientDetail?.clientId) {
      onGetAddHomePref(clientDetail.clientId);
    }
    if (prevState.forDate !== this.state.forDate && this.state.forDate !== "") {
      this.fetchRouteData();
    }
    if (prevProps.addListings !== this.props.addListings) {
      this.filterListings();
    }
  }
  fetchRouteData = async () => {
    const { agentId, clientId, forDate } = this.state;
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    try {
      const response = await axios.get(
        `${API_URL}ClientPotentialListingsShowingRoute/fixedAllGrouped?AgentId=${agentId}&ClientId=${clientId}`,
        { headers } // Passing headers
      );
      this.setState({ routeData: response.data });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  handlePlaceSelected = (address, index, setFieldValue) => {
    geocodeByAddress(address)
      .then(results => {
        const place = results[0];
        const addressComponents = place.address_components;
        const getComponent = (types) => {
          const component = addressComponents.find((component) =>
            types.every((type) => component.types.includes(type))
          );
          return component ? component.long_name : '';
        };
        const latitude = place.geometry.location.lat();
        const longitude = place.geometry.location.lng();
        setFieldValue(`createClientPotentialListingLists.${index}.listingAddress`, place.formatted_address);
        setFieldValue(`createClientPotentialListingLists.${index}.listingCity`, getComponent(['locality', 'political']));
        //setFieldValue('longitude', longitude);
        //setFieldValue('latitude', latitude);
      })
      .catch(error => console.error('Error', error));
  };
  handlePlaceSelectedDate = (address, setFieldValue) => {
    geocodeByAddress(address)
      .then(results => {
        const place = results[0];
        const addressComponents = place.address_components;
        const getComponent = (types) => {
          const component = addressComponents.find((component) =>
            types.every((type) => component.types.includes(type))
          );
          return component ? component.long_name : '';
        };
        const streetNumber = getComponent(['street_number']);
        const route = getComponent(['route']);
        const city = getComponent(['locality', 'political']);
        const province = getComponent(['administrative_area_level_1', 'political']);
        const postalCode = getComponent(['postal_code']);
        const country = getComponent(['country', 'political']);
        const modifiedAddress = `${streetNumber} ${route}`;
        const latitude = place.geometry.location.lat();
        const longitude = place.geometry.location.lng();
        setFieldValue(`destinationAddress`, place.formatted_address);
        setFieldValue(`fullAddress`, place.formatted_address);
        setFieldValue(`addressLine1`, modifiedAddress);
        setFieldValue(`addressLine2`, city);
        setFieldValue(`city`, city);
        setFieldValue(`province`, province);
        setFieldValue(`postal`, postalCode);
        setFieldValue(`country`, country);
        setFieldValue(`longitude`, longitude);
        setFieldValue(`latitude`, latitude);
      })
      .catch(error => console.error('Error', error));
  };
  toggle1(tab) {
    if (this.state.activeTab1 !== tab) {
      this.setState({
        activeTab1: tab,
      });
    }
  }
  handleChange = (activeStatus, itemId) => {
  };
  toggleCreateRoute() {
    this.setState({ addListing: "", isRoute: !this.state.isRoute });
  }
  togglePrefrences() {
    this.setState({ pref: "", isPref: !this.state.isPref });
  }
  handleChangeStatus = async (arg) => {
    const addListing = arg;
    try {
      toast.loading("Please wait...");
      const updateSt = {
        clientPotentialListingId: addListing?.clientPotentialListingId,
        isInterested: !addListing.isInterested,
        agentId: parseInt(localStorage.getItem('agentId')),
        clientId: parseInt(localStorage.getItem('userId'))
      };
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;
      const apiUrl = `${API_URL}ClientPotentialListing/ClientMarkInterested`;
      const response = await axios.post(apiUrl, updateSt, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200 || response.status === 201) {
        toast.dismiss();
        toast.success("Status changed successfully");
        // Call the function to refresh listings
        const { onGetClientAddListing } = this.props;
        onGetClientAddListing(
          localStorage.getItem("userId"),
          localStorage.getItem("agentId")
        );
      }
    } catch (error) {
      toast.dismiss();
      toast.error("Failed to update status");
      console.error("Error updating status:", error);
    }
  };
  fetchAnswerWithStandard(listingId, clientGuid) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    const params = {
      clientId: clientGuid,
      ShowingId: listingId,
      agentId: localStorage.getItem('agentId')
    };
    axios
      .get(`${API_URL}ClientAdditionalHomePreferenceAnswer/allwithstandard`, { headers, params })
      .then((response) => {
        this.setState({ answerWithStandards: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }
  handleDateChange = (value) => {
    this.setState({ forDate: value[0] });
  };
  handleCompare = async () => {
    const { selectedListings } = this.state;
    console.log(selectedListings);
    const payload = {
      showingIds: selectedListings,
      clientId: parseInt(localStorage.getItem("userId")),
      agentId: parseInt(localStorage.getItem("agentId")),
    };
    try {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;
      const response = await axios.post(`${API_URL}ClientPotentialListing/comparelistings`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        this.props.history.push({
          pathname: "/compare-match",
          state: { compareData: response.data, clientId: this.props.clientDetail?.clientId, currencyCode: this.props.userdetail?.agentDefaultCurrencyCode },
        });
      }
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };
  toggleCollapse = (index) => {
    this.setState((prevState) => ({
      [`col${index}`]: !prevState[`col${index}`],
    }));
  };
  handleInsertAi = (generatedText, setFieldValue) => {
    setFieldValue("notes", generatedText);
  };
  handleHomePrefSubmit(value) {
    const payload = {
      id: value.id,
      clientStandardHomePreferenceId: value.clientStandardHomePreferenceId,
      typeOfHouse: value.typeOfHouse,
     minPrice : value.minPrice ? parseInt(value.minPrice, 10) : 0,
      maxPrice : value.maxPrice ? parseInt(value.maxPrice, 10) : 0,
      sqFeets: value.sqFeets,
      bedRoom: value.bedRoom,
      bathRoom: value.bathRoom,
      clientId: parseInt(value.clientId),
      clientGuid: value.clientGuid,
      city: value.city,
      preferenceDescription: value.preferenceDescription
    }
    if (value.id > 0) {
      this.props.updateHomePref(payload, (status) => {
        if (status == true) {
          this.togglePrefrences();
        }
      });
    } else {
      this.props.postHomePref(payload, (status) => {
        if (status == true) {
          this.togglePrefrences();
        }
      });
    }
  }
  submitAddHomePrefData = (value, actions) => {
    const payload = {
      clientId: parseInt(value.clientId),
      agentId: parseInt(localStorage.getItem('agentId')),
      clientGuid: value.clientGuid,
      clientAdditionalHomePreferenceTitle: value.clientAdditionalHomePreferenceTitle,
      clientAdditionalHomePreferenceDescription: value.clientAdditionalHomePreferenceDescription,
      clientAdditionalHomePreferenceIsActive: value.clientAdditionalHomePreferenceIsActive
    }
    this.props.createAddHomePref(payload);
    actions.resetForm();
    
    
  }
  fetchListingShowingHistory(listingId) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    const params = {
      clientId: localStorage.getItem('userId'),
      agentId: localStorage.getItem('agentId'),
      listingId: listingId
    }
    axios
      .get(`${API_URL}ClientPotentialListingShowingHistory/allbylistingid`, { headers, params })
      .then((response) => {
        this.setState({ schedules: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }
handelFavSubmit = async (value) => {
  const { onGetClientAddListing } = this.props;
  const toastId = toast.loading("Please wait...");
  try {
    const payload ={
        clientPotentialListingId: value.clientPotentialListingId,
        isFavourite: true,
        clientId: parseInt(localStorage.getItem('userId')),
        agentId: parseInt(localStorage.getItem('agentId'))
    }
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const response = await axios.post(
      `${API_URL}ClientPotentialListing/ClientMarkFavourite`,
      payload, 
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    toast.dismiss(toastId);
   toast.success("Submitted successfully!");
    onGetClientAddListing(localStorage.getItem('userId'), localStorage.getItem('agentId'))

    console.log("API response:", response.data);
  } catch (err) {
    // Dismiss loading toast
    toast.dismiss(toastId);

    // Error toast
    toast.error("Something went wrong");
    console.error("API error:", err.response || err.message);
  }
};
handelUnFavSubmit = async (value) => {
  const { onGetClientAddListing } = this.props;
  const toastId = toast.loading("Please wait...");
  try {
    const payload ={
        clientPotentialListingId: value.clientPotentialListingId,
        isFavourite: false,
         clientId: parseInt(localStorage.getItem('userId')),
        agentId: parseInt(localStorage.getItem('agentId'))
    }
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const response = await axios.post(
      `${API_URL}ClientPotentialListing/ClientMarkFavourite`,
      payload, 
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    toast.dismiss(toastId);
   toast.success("Submitted successfully!");
    onGetClientAddListing(localStorage.getItem('userId'), localStorage.getItem('agentId'))

    console.log("API response:", response.data);
  } catch (err) {
    // Dismiss loading toast
    toast.dismiss(toastId);

    // Error toast
    toast.error("Something went wrong");
    console.error("API error:", err.response || err.message);
  }
};
 toggleViewFav() {
    this.setState({ isFav: !this.state.isFav });
    this.fetchFav();
  }

   fetchFav() {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    const params = {
      clientId: localStorage.getItem('userId'),
      agentId: localStorage.getItem('agentId'),
      
    }
    axios
      .get(`${API_URL}ClientPotentialListing/allFavourite`, { headers, params })
      .then((response) => {
        this.setState({ favourites: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }
  render() {
    const { lightboxOpen, photoIndex } = this.state;
    const { addListings, loading, listingtypes, clientDetail, userdetail, homeprefrences, onUpdateHomePref, addprefrences, onUpdateAddPref } = this.props;
    const { addListing, messageData, imagesData, selectedListings, answerWithStandards, routeData, schedules } = this.state;
    const { isEdit, deleteModal, homeprefrence, addprefrence, isUpdateEdit } = this.state;
    const { impdestinations, onUpdateImpDestination } = this.props;
    const { impdestination, isEdits, deleteModalDates } = this.state;
    const imageUrls = imagesData?.map((img) => img.clientPotentialListingImageLink);
    const Offsymbol = () => {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            fontSize: 12,
            color: "#fff",
            paddingRight: 13
          }}
        >
          {" "}
          No
        </div>
      )
    }
    const OnSymbol = props => {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            fontSize: 12,
            color: "#fff",
            paddingRight: -2
          }}
        >
          {" "}
          Yes
        </div>
      )
    }
    console.log(clientDetail);
    return (
      <React.Fragment>
        {this.props.loading && this.props.loading ? (
          <div className="loading">Loading&#8230;</div>
        ) : null}
        <DeleteModal
          show={deleteModal}
          onDeleteClick={this.handleDeleteHomePref}
          onCloseClick={() => this.setState({ deleteModal: false })}
        />
        <ToastContainer autoClose={2000} />
        <div className="page-content">
          <MetaTags>
            <title>Add Listing  | Realty Space</title>
          </MetaTags>
          <Container fluid>
            {/* <Breadcrumbs
              title={this.props.t("Buyer")}
              breadcrumbItem={this.props.t("Listings ")}
            /> */}
            <Row>
              <Col xl="12">
                <Formik
                  enableReinitialize={true}
                  initialValues={{
                    createClientPotentialListingLists: [{
                      agentId: localStorage.getItem('agentId'),
                      clientId: localStorage.getItem('userId'),
                      engagementId: '',
                      mlsId: "",
                      mlsurl: "",
                      listingDate: new Date(),
                      isInterested: true,
                      isActive: true,
                      addedBy: 'agent',
                      listingAddress: '',
                      listingtype: '',
                      listedPrice: "",
                      listingCity: "",
                      notes: "",
                      listingBedroom: "",
                      listingBathroom: "",
                      listingSqFt: '',
                      listingParking:''
                    }]
                  }}
                  validationSchema={Yup.object().shape({
                    createClientPotentialListingLists: Yup.array().of(
                      Yup.object().shape({
                        engagementId: Yup.string().required("This is Required"),
                        mlsId: Yup.string().required("This is Required"),
                         listedPrice: Yup.number()
                                .typeError("Invalid Price")
                                .positive("Price must be greater than 0")
                                .required("This is Required"),

                        listingBathroom: Yup.number().typeError('Invalid Number'),
                        listingBedroom: Yup.string().typeError('This is Required'),
                        listingParking: Yup.number().typeError('Invalid Number'),
                        listingCity: Yup.string().required("This is Required"),
                        listingAddress:Yup.string().required("This is Required"),
                      })
                    )
                  })}
                  onSubmit={this.handleAddListingSubmit}
                >
                  {({ errors, touched, values, handleChange, handleBlur, setFieldValue, setFieldTouched }) => (
                    <Form
                      className="needs-validation"
                    >
                      <Card className="rs-card-bg">
                        <CardBody>
                          <h5 className="pb-2 text-uppercase">Add new Listing</h5>
                          <FieldArray name="createClientPotentialListingLists">
                            {({ insert, remove, push }) => (
                              <div>
                                {values.createClientPotentialListingLists.map((listing, index) => (
                                  <div key={index}>
                                    <Row>
                                      <Col sm="2">
                                        <EngagementListBuyerClient
                                          name={`createClientPotentialListingLists.${index}.engagementId`}
                                          value={listing.engagementId}
                                          onChange={(val) => setFieldValue(`createClientPotentialListingLists.${index}.engagementId`, val)}
                                          clientId={localStorage.getItem('userId')}
                                          agentId={localStorage.getItem('agentId')}
                                          typeId={1}
                                          statusId={0}
                                        />
                                      </Col>
                                      <Col sm="2">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor={`createClientPotentialListingLists.${index}.mlsId`}>
                                            {this.props.t("Unit ID# * (MlS# etc)")}
                                          </Label>
                                          <Field
                                            name={`createClientPotentialListingLists.${index}.mlsId`}
                                            onChange={handleChange}
                                            type="text"
                                            className={"form-control" + (errors.createClientPotentialListingLists?.[index]?.mlsId && touched.createClientPotentialListingLists?.[index]?.mlsId ? " is-invalid" : "")}
                                            id={`createClientPotentialListingLists.${index}.mlsId`}
                                          />
                                          <ErrorMessage
                                            name={`createClientPotentialListingLists.${index}.mlsId`}
                                            component="div"
                                            className="invalid-feedback"
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col sm="3">
                                          <FormGroup className="mb-3">
                                              <Label>Address *</Label>
                                              <PlacesAutocomplete
                                                value={values.createClientPotentialListingLists[index].listingAddress}
                                                onChange={(value) => setFieldValue(`createClientPotentialListingLists.${index}.listingAddress`, value)}
                                                onSelect={(value) => this.handlePlaceSelected(value, index, setFieldValue)}
                                              >
                                                {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                                  <div>
                                                   <input
                                                    {...getInputProps({
                                                      name: `createClientPotentialListingLists.${index}.listingAddress`,
                                                      placeholder: "Enter Address...",
                                                      className: `form-control ${
                                                        errors.createClientPotentialListingLists?.[index]?.listingAddress &&
                                                        touched.createClientPotentialListingLists?.[index]?.listingAddress
                                                          ? "is-invalid"
                                                          : ""
                                                      }`,
                                                      onBlur: () => setFieldTouched(`createClientPotentialListingLists.${index}.listingAddress`, true), // ✅ force Formik touched
                                                    })}
                                                  />
                                                    <div>
                                                      {loading && <div>Loading...</div>}
                                                      {suggestions.map((suggestion, i) => {
                                                        const style = {
                                                          backgroundColor: suggestion.active ? '#007BFF' : '#fff',
                                                          color: suggestion.active ? '#fff' : '#000',
                                                          padding: '10px',
                                                          cursor: 'pointer',
                                                        };
                                                        return (
                                                          <div key={i} {...getSuggestionItemProps(suggestion, { style })}>
                                                            {suggestion.description}
                                                          </div>
                                                        );
                                                      })}
                                                    </div>
                                                  </div>
                                                )}
                                              </PlacesAutocomplete>
                                             {errors.createClientPotentialListingLists?.[index]?.listingAddress &&
                                              touched.createClientPotentialListingLists?.[index]?.listingAddress ? (
                                                <div className="invalid-feedback d-block">
                                                  {errors.createClientPotentialListingLists[index].listingAddress}
                                                </div>
                                              ) : null}
                                            </FormGroup>
                                      
                                      </Col>
                                      <Col sm="3">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor={`createClientPotentialListingLists.${index}.mlsurl`}>
                                            {this.props.t("Public Link (MlS link etc)")}
                                          </Label>
                                          <Field
                                            name={`createClientPotentialListingLists.${index}.mlsurl`}
                                            onChange={handleChange}
                                            type="text"
                                            className={"form-control" + (errors.createClientPotentialListingLists?.[index]?.mlsurl && touched.createClientPotentialListingLists?.[index]?.mlsurl ? " is-invalid" : "")}
                                            id={`createClientPotentialListingLists.${index}.mlsurl`}
                                          />
                                          <ErrorMessage
                                            name={`createClientPotentialListingLists.${index}.mlsurl`}
                                            component="div"
                                            className="invalid-feedback"
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col sm="2">
                                        <FormGroup className="mb-3">
                                          <Label>
                                            {values.createClientPotentialListingLists[index].buyerType === 1
                                              ? "Monthly Rent*"
                                              : "Listed Price*"}
                                          </Label>
                                          {/* <CurrencyInput
                                            id={`createClientPotentialListingLists.${index}.listedPrice`}
                                            name={`createClientPotentialListingLists.${index}.listedPrice`}
                                            className="form-control"
                                            value={values.createClientPotentialListingLists[index].listedPrice || ""}
                                            decimalsLimit={2}
                                            prefix={userdetail?.agentDefaultCurrencyCode + " "}
                                            onValueChange={(value) => {
                                              setFieldValue(`createClientPotentialListingLists.${index}.listedPrice`, value);
                                            }}
                                          /> */}
                                          
                                          {/* <Field
                                            name={`createClientPotentialListingLists.${index}.listedPrice`}
                                            onChange={handleChange}
                                            type="text"
                                            className={"form-control" + (errors.createClientPotentialListingLists?.[index]?.listedPrice && touched.createClientPotentialListingLists?.[index]?.listedPrice ? " is-invalid" : "")}
                                            id={`createClientPotentialListingLists.${index}.listedPrice`}
                                          /> */}
                                          <Field name={`createClientPotentialListingLists.${index}.listedPrice`}>
                                              {({ field, form }) => (
                                                <div>
                                                  <CurrencyInput
                                                    id={field.name}
                                                    name={field.name}
                                                    className={`form-control${
                                                      form.errors.createClientPotentialListingLists?.[index]?.listedPrice &&
                                                      form.touched.createClientPotentialListingLists?.[index]?.listedPrice
                                                        ? " is-invalid"
                                                        : ""
                                                    }`}
                                                    prefix={userdetail?.agentDefaultCurrencyCode + " " || "$"}
                                                    value={field.value || ""}
                                                    decimalsLimit={2}
                                                    onValueChange={(val) => {
                                                      form.setFieldValue(field.name, val);
                                                    }}
                                                    onBlur={() => form.setFieldTouched(field.name, true)} 
                                                  />
                                                  <ErrorMessage
                                                    name={`createClientPotentialListingLists.${index}.listedPrice`}
                                                    component="div"
                                                    className="invalid-feedback"
                                                  />
                                                </div>
                                              )}
                                            </Field>
                                              <ErrorMessage name={`createClientPotentialListingLists.${index}.listedPrice`} component="div" className="invalid-feedback" />
                                        </FormGroup>
                                      </Col>
                                      <Col sm="2">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor={`createClientPotentialListingLists.${index}.listingCity`}>
                                            {this.props.t("City")}
                                          </Label>
                                          <Field
                                            name={`createClientPotentialListingLists.${index}.listingCity`}
                                            onChange={handleChange}
                                            type="text"
                                            className={"form-control" + (errors.createClientPotentialListingLists?.[index]?.listingCity && touched.createClientPotentialListingLists?.[index]?.listingCity ? " is-invalid" : "")}
                                            id={`createClientPotentialListingLists.${index}.listingCity`}
                                          />
                                          <ErrorMessage
                                            name={`createClientPotentialListingLists.${index}.listingCity`}
                                            component="div"
                                            className="invalid-feedback"
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col sm="2">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor={`createClientPotentialListingLists.${index}.listingType`}>
                                            {this.props.t("Type")}
                                          </Label>
                                          <Field as="select" name={`createClientPotentialListingLists.${index}.listingType`}
                                            className={"form-control" + (errors.createClientPotentialListingLists?.[index]?.listingType && touched.createClientPotentialListingLists?.[index]?.listingType ? " is-invalid" : "")}
                                            onChange={handleChange}>
                                            <option value="">Select</option>
                                            {map(listingtypes, (listingtype, classkey) => (
                                              <option key={classkey} value={listingtype.id}>{listingtype.listingTypeTitle}</option>
                                            ))}
                                          </Field>
                                          <ErrorMessage
                                            name={`createClientPotentialListingLists.${index}.listingType`}
                                            component="div"
                                            className="invalid-feedback"
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col sm="1">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor={`createClientPotentialListingLists.${index}.listingBedroom`}>
                                            {this.props.t("Bedroom")}
                                          </Label>
                                          <Field
                                            name={`createClientPotentialListingLists.${index}.listingBedroom`}
                                            onChange={handleChange}
                                            type="text"
                                            className={"form-control" + (errors.createClientPotentialListingLists?.[index]?.listingBedroom && touched.createClientPotentialListingLists?.[index]?.listingBedroom ? " is-invalid" : "")}
                                            id={`createClientPotentialListingLists.${index}.listingBedroom`}
                                          />
                                          <ErrorMessage
                                            name={`createClientPotentialListingLists.${index}.listingBedroom`}
                                            component="div"
                                            className="invalid-feedback"
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col sm="1">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor={`createClientPotentialListingLists.${index}.listingBathroom`}>
                                            {this.props.t("Bathroom")}
                                          </Label>
                                          <Field
                                            name={`createClientPotentialListingLists.${index}.listingBathroom`}
                                            onChange={handleChange}
                                            type="text"
                                            className={"form-control" + (errors.createClientPotentialListingLists?.[index]?.listingBathroom && touched.createClientPotentialListingLists?.[index]?.listingBathroom ? " is-invalid" : "")}
                                            id={`createClientPotentialListingLists.${index}.listingBathroom`}
                                          />
                                          <ErrorMessage
                                            name={`createClientPotentialListingLists.${index}.listingBathroom`}
                                            component="div"
                                            className="invalid-feedback"
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col sm="1">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor={`createClientPotentialListingLists.${index}.listingParking`}>
                                            {this.props.t("Parking")}
                                          </Label>
                                          <Field
                                            name={`createClientPotentialListingLists.${index}.listingParking`}
                                            onChange={handleChange}
                                            type="text"
                                            className={"form-control" + (errors.createClientPotentialListingLists?.[index]?.listingParking && touched.createClientPotentialListingLists?.[index]?.listingParking ? " is-invalid" : "")}
                                            id="mls"
                                          />
                                          <ErrorMessage
                                            name={`createClientPotentialListingLists.${index}.listingParking`}
                                            component="div"
                                            className="invalid-feedback"
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col sm="1">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor={`createClientPotentialListingLists.${index}.listingSqFt`}>
                                            {this.props.t("Sq. Ft")}
                                          </Label>
                                          <Field
                                            name={`createClientPotentialListingLists.${index}.listingSqFt`}
                                            onChange={handleChange}
                                            type="text"
                                            className={"form-control" + (errors.createClientPotentialListingLists?.[index]?.listingSqFt && touched.createClientPotentialListingLists?.[index]?.listingsqft ? " is-invalid" : "")}
                                            id="mls"
                                          />
                                          <ErrorMessage
                                            name={`createClientPotentialListingLists.${index}.listingSqFt`}
                                            component="div"
                                            className="invalid-feedback"
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col sm="2">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor={`createClientPotentialListingLists.${index}.notes`}>
                                            {this.props.t("Notes")}
                                          </Label>
                                          <Field
                                            name={`createClientPotentialListingLists.${index}.notes`}
                                            onChange={handleChange}
                                            type="text"
                                            className={"form-control" + (errors.createClientPotentialListingLists?.[index]?.notes && touched.createClientPotentialListingLists?.[index]?.notes ? " is-invalid" : "")}
                                            id={`createClientPotentialListingLists.${index}.notes`}
                                          />
                                          <ErrorMessage
                                            name={`createClientPotentialListingLists.${index}.notes`}
                                            component="div"
                                            className="invalid-feedback"
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col sm="2">
                                        {index == 0 && (
                                          <Button type="button" style={{ marginTop: 28 }} className="btn btn-primary" onClick={() => push({
                                            clientId: parseInt(localStorage.getItem('userId')),
                                            agentId: parseInt(localStorage.getItem('agentId')),
                                            mlsId: "",
                                            mlsurl: "",
                                            listingAddress: "",
                                            listedPrice: "",
                                            listingType: "",
                                            listingCity: "",
                                            notes: "",
                                            listingBedroom: "",
                                            listingBathroom: "",
                                            listingParking: "",
                                            listingDate: new Date(),
                                            isInterested: true,
                                            isActive: true,
                                            addedBy: 'agent',
                                          })}><i className=" bx bx-plus-medical" /></Button>
                                        )}
                                        {index !== 0 && (
                                          <>
                                          <Button
                                            type="button"
                                            className="btn btn-danger"
                                            onClick={() => remove(index)}
                                            style={{ marginTop: 28, borderRadius:15 }}
                                          >
                                            <i className="bx bx-trash"></i>
                                          </Button>{" "}
                                           <Button type="button" style={{ marginTop: 28 }} className="btn btn-primary" onClick={() => push({
                                            clientId: parseInt(localStorage.getItem('userId')),
                                            agentId: parseInt(localStorage.getItem('agentId')),
                                            mlsId: "",
                                            mlsurl: "",
                                            listingAddress: "",
                                            listedPrice: "",
                                            listingType: "",
                                            listingCity: "",
                                            notes: "",
                                            listingBedroom: "",
                                            listingBathroom: "",
                                            listingParking: "",
                                            listingDate: new Date(),
                                            isInterested: true,
                                            isActive: true,
                                            addedBy: 'agent',
                                          })}><i className=" bx bx-plus-medical" /></Button>
                                          </>
                                        )}
                                        
                                      </Col>
                                    </Row>
                                  </div>
                                ))}
                              </div>
                            )}
                          </FieldArray>
                          <button type="submit" className="btn btn-primary">Save</button>
                        </CardBody>
                      </Card>
                    </Form>
                  )}
                </Formik>
                <Row>
                  <Col sm="12">
                    <Card className="rs-card-bg">
                      <CardHeader>
                        <Row className="gy-3">
                          {/* Left Column - Buttons */}
                          <Col lg="6" md="12">
                            <div className="text-uppercase d-flex align-items-center gap-2">
                              <Link
                                to="#"
                                onClick={this.togglePrefrences}
                                className="btn btn-outline-secondary bt-for"
                              >
                                <span className="d-flex align-items-center gap-2">
                                  Set home preferences
                                  <img style={{ height: 16 }} src={houseIcon} alt="house" />
                                </span>
                              </Link>
                              <Link
                                to="#"
                                onClick={this.toggleCreateRoute}
                                className="btn btn-outline-secondary bt-for"
                              >
                                <span className="d-flex align-items-center gap-2">
                                  View routes
                                  <img style={{ height: 16 }} src={viewRouteImg} alt="view routes" />
                                </span>
                              </Link>
                              <Link
                                to="#"
                                onClick={this.toggleViewFav}
                                className="btn btn-outline-secondary bt-for"
                              >
                                <span className="d-flex align-items-center gap-2">
                                  View favourites
                                  <img style={{ height: 16 }} src={hRedIcon} alt="View favourites" />
                                </span>
                              </Link>
                              {selectedListings?.length > 0 ? (
                                <Link
                                  to="#"
                                  onClick={this.handleCompare}
                                  className="btn btn-outline-secondary bt-for"
                                >
                                  <span className="d-flex align-items-center gap-2">
                                    Compare ({selectedListings?.length || 0} / {addListings?.length || 0})
                                    <img style={{ height: 16 }} src={compareImg} alt="compare" />
                                  </span>
                                </Link>
                              ) : (
                                <span
                                  className="btn btn-outline-secondary disabled bt-for"
                                  style={{ pointerEvents: "none", opacity: 0.5 }}
                                >
                                  <span className="d-flex align-items-center gap-2">
                                    Compare ({selectedListings?.length || 0} / {addListings?.length || 0})
                                    <img style={{ height: 16 }} src={compareImg} alt="compare" />
                                  </span>
                                </span>
                              )}
                            </div>
                          </Col>
                          {/* Right Column - Filters */}
                          <Col lg="6" md="12">
                            <div className="d-flex flex-wrap gap-2">
                              {/* Listing Type */}
                              <div className="flex-grow-1" style={{ minWidth: "150px" }}>
                                <label className="visually-hidden" htmlFor="listingType">
                                  Type
                                </label>
                                <select
                                  id="listingType"
                                  className="form-select select-filter"
                                  value={this.state.listingType}
                                  onChange={this.handleListingTypeChange}
                                >
                                  <option value="0">All Type Of Listing</option>
                                  <option value="1">Sent by Agent</option>
                                  <option value="2">Sent to Agent</option>
                                  <option value="3">Scheduled</option>
                                  <option value="4">Upcoming</option>
                                  <option value="5">Not Scheduled</option>
                                  <option value="6">Listings accepted to view</option>
                                  <option value="7">Listings declined to view</option>
                                   <option value="8">My favourites</option>
                                </select>
                              </div>
                              {/* Listing Status */}
                              <div className="flex-grow-1" style={{ minWidth: "150px" }}>
                                <label className="visually-hidden" htmlFor="listingStatus">
                                  Status
                                </label>
                                <select
                                  id="listingStatus"
                                  className="form-select select-filter"
                                  value={this.state.listingStatus}
                                  onChange={this.handleStatusChange}
                                >
                                  <option value="0">All Status...</option>
                                  <option value="1">Available</option>
                                  <option value="2">Not Available</option>
                                  <option value="3">Sold</option>
                                  <option value="4">Sold Conditionally</option>
                                </select>
                              </div>
                              {/* Search Box */}
                              <div className="flex-grow-1 position-relative" style={{ minWidth: "200px" }}>
                                <div className="input-group">
                                  <Input
                                    type="text"
                                    className="form-control select-filter"
                                    placeholder="Search MLS#, City"
                                    aria-label="Search MLS#, City"
                                    aria-describedby="button-addon2"
                                    value={this.state.searchQuery}
                                    onChange={this.handleInputChange}
                                  />
                                  {this.state.searchQuery && (
                                    <button
                                      className="btn btn-clear position-absolute"
                                      style={{
                                        right: "40px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        background: "transparent",
                                        border: "none",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => this.setState({ searchQuery: "" })}
                                    >
                                      ✖
                                    </button>
                                  )}
                                  <button className="btn btn-search" type="button" id="button-addon2"><i className="bx bx-search font-size-18"></i></button>
                                </div>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </CardHeader>
                      <CardBody>
                        <div className="clearfix"></div>
                        <h5 className="card-title mb20 text-uppercase">All Listings
                        </h5>
                        <div className="table-responsive">
                          <table className="table mb-0 table">
                            <thead>
                              <tr>
                                <th></th>
                                <th>Date</th>
                                <th>Unit ID</th>
                                <th>Asking price</th>
                                <th className="hide-city-col">Address</th>
                                <th>Status </th>
                                {/* <th>Like / Dislike </th> */}
                                <th>Showing</th>
                                <th>Interested</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {map(this.state.filteredListings, (addListing, lkey) => (
                                <tr key={"_alist_" + lkey}>
                                  <td><input type='checkbox' name='checkbox'
                                    onChange={(e) => this.handleCheckboxChange(addListing.id, e)}
                                  /></td>
                                  <td>
                                    {/* {addListing.addedBy == 'client' ? <img className="listing-img" src={uploadView} /> : <img className="listing-img" src={downloadView} />}  */}
                                  
                                  <Moment format="DD MMM, YYYY">{addListing.listingDate}</Moment></td>
                                  <td><a target="_blank" rel="noreferrer" href={addListing.mlsurl}>{addListing.mlsId} <i className=" bx bx-link-external"></i></a></td>
                                  <td><CurrencyFormat value={addListing.listedPrice} displayType={'text'} thousandSeparator={true} prefix={userdetail?.agentDefaultCurrencyCode + " "} />
                                  </td>
                                  <td className="hide-city-col">{addListing.listingAddress} {addListing.listingCity} 
                                    {addListing.isFavourite ? (
                                       <Link to="#" onClick={()=> this.handelUnFavSubmit(addListing)}><img src={hRedIcon} className="ms-2" width="16px" /></Link>
                                        
                                    ):(
                                       <Link to="#" onClick={()=> this.handelFavSubmit(addListing)}><img src={hGreenIcon} className="ms-2" width="16px" /></Link>
                                    )}
                                    
                                    
                                    </td>
                                  <td>{addListing.listingStatusId ? this.getStatus(addListing.listingStatusId) : "N/a"}</td>
                                  <td>
                                    {addListing.showingStatusId == 1 ? (
                                      <>
                                        <Moment format="MMM DD">{addListing.showingDate}</Moment> / {addListing.startTime || 'N/a'}
                                      </>
                                    ) : (
                                      'N/a'
                                    )}
                                  </td>
                                  <td><Switch onColor="#50C878" width={65} uncheckedIcon={<Offsymbol />} checkedIcon={<OnSymbol />} onChange={isInterested => this.handleChangeStatus(addListing)} checked={addListing.isInterested} /></td>
                                  <td>
                                    <Link to="#" className="header-item noti-icon-mesaage me-3"> <img src={messageIcon} style={{ width: 32 }} /> <span className="badge bg-blue bg-danger rounded-pill">{addListing.newMessageCount}</span></Link> {" "}
                                    <Link to="#" onClick={() => this.toggleRightCanvas(addListing)} className="btn btn-manage">Manage</Link>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
          <Offcanvas
            isOpen={this.state.isRight}
            direction="end"
            toggle={this.toggleRightCanvas}
            style={{ width: 800 }}
          >
            <OffcanvasHeader toggle={this.toggleRightCanvas}>
              Manage Listing
            </OffcanvasHeader>
            <OffcanvasBody>
              <Nav pills className="navtab-bg nav-justified">
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      active: this.state.activeTab1 === "1",
                    })}
                    onClick={() => {
                      this.toggle1("1");
                    }}
                  >
                    Info
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      active: this.state.activeTab1 === "3",
                    })}
                    onClick={() => {
                      this.toggle1("3");
                    }}
                  >
                    Message
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      active: this.state.activeTab1 === "5",
                    })}
                    onClick={() => {
                      this.toggle1("5");
                    }}
                  >
                    Re-schedule
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      active: this.state.activeTab1 === "2",
                    })}
                    onClick={() => {
                      this.toggle1("2");
                    }}
                  >
                    Notes after visit
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      active: this.state.activeTab1 === "4",
                    })}
                    onClick={() => {
                      this.toggle1("4");
                    }}
                  >
                    Images
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent
                activeTab={this.state.activeTab1}
                className="p-3 text-muted"
              >
                <TabPane tabId="1">
                  <div className="tabContent info-listing">
                    <table className="align-middle mb-0 table">
                      <tbody>
                        <tr>
                          <th scope="row" style={{ width: '25%' }}>Unit Id</th>
                          <td>
                            {addListing?.mlsId}
                            <span style={{ marginLeft: 100 }}>
                              {addListing?.listingAddress && (
                                <a
                                  href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(addListing.listingAddress)}`}
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  <i className="bx bx-map-alt font-size-18"></i>
                                </a>
                              )}
                              {" "}
                              {addListing?.mlsurl && (
                                <a href={addListing.mlsurl} target="_blank" rel="noreferrer">
                                  <i className="bx bx-link-external font-size-18"></i>
                                </a>
                              )}
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">Status</th>
                          <td>{addListing?.listingStatusId ? this.getStatus(addListing?.listingStatusId) : ''}</td>
                        </tr>
                        <tr>
                          <th scope="row">Sent/Received date</th>
                          <td><Moment format="DD MMM YYYY">{addListing?.listingDate}</Moment></td>
                        </tr>
                        {addListing?.showingDate ?
                          <tr>
                            <th scope="row">Visit date</th>
                            <td>{addListing?.showingDate ? moment(addListing.showingDate).format("MMM D, YYYY") : ""} @ {addListing?.startTime ? moment(addListing.startTime).format("hh:mm A") : ""}  <span className="float-end"><Link to="#" onClick={() => {
                              this.toggle1("5");
                            }}>Re-schedule</Link></span></td>
                          </tr>
                          : ''}
                        <tr>
                          <th scope="row">Address</th>
                          <td>{addListing?.listingAddress}</td>
                        </tr>
                        <tr>
                          <th scope="row">Price</th>
                          <td><CurrencyFormat value={addListing?.listedPrice} displayType={'text'} thousandSeparator={true} prefix={userdetail?.agentDefaultCurrencyCode + " "} /></td>
                        </tr>
                        <tr>
                          <th scope="row">Square feet</th>
                          <td>{addListing?.listingSqFt || 'n/a'}</td>
                        </tr>
                        <tr>
                          <th scope="row">Bedroom</th>
                          <td>{addListing?.listingBedroom || 'n/a'}</td>
                        </tr>
                        <tr>
                          <th scope="row">Bathrooms</th>
                          <td>{addListing?.listingBathroom || 'n/a'}</td>
                        </tr>
                        <tr>
                          <th scope="row">Parking</th>
                          <td>{addListing?.listingParking ? addListing?.listingParking : 'n/a'}</td>
                        </tr>
                        <tr>
                          <th scope="row">Notes</th>
                          <td> {addListing?.notes}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </TabPane>
                <TabPane tabId="2">
                  <div className="tabContent info-listing">
                    <Row className="mb-2">
                      <Col sm="6">
                        <h4>Property Features</h4>
                      </Col>
                      <Col sm="6">
                      </Col>
                    </Row>
                    <Formik
                      enableReinitialize={true}
                      initialValues={{
                        id: answerWithStandards?.id || 0,
                        clientStandardHomePreferenceAnswerId: answerWithStandards?.clientStandardHomePreferenceAnswerId || "00000000-0000-0000-0000-000000000000",
                        listingType: addListing?.listingtype ? addListing?.listingtype : answerWithStandards?.typeOfHouse || "",
                        listedPrice: addListing?.listedPrice ? addListing?.listedPrice : answerWithStandards?.minPrice || "",
                        listingCity: addListing?.listingCity ? addListing?.listingCity : answerWithStandards?.city || "",
                        listingBedroom: addListing?.listingBathroom ? addListing?.listingBedroom : answerWithStandards?.bedRoom || "",
                        listingBathroom: addListing?.listingBathroom ? addListing?.listingBathroom : answerWithStandards?.bathRoom || "",
                        sqFeets: addListing?.listingSqFt ? addListing?.listingSqFt : answerWithStandards?.sqFeets || "",
                        whatYouLike: answerWithStandards?.whatYouLike || "",
                        whatYouDislike: answerWithStandards?.whatYouDislike || "",
                        createClientAdditionalHomePreferenceAnswers: answerWithStandards?.createClientAdditionalHomePreferenceAnswers || [],
                      }}
                      validationSchema={Yup.object().shape({
                        // listingType: Yup.string().required("Required"),
                        // listedPrice: Yup.number().required("Required"),
                        // listingCity: Yup.string().required("Required"),
                        // listingBedroom: Yup.string().required("Required"),
                        // listingBathroom: Yup.string().required("Required"),
                        // sqFeets: Yup.string().required("Required"),
                      })}
                      onSubmit={async (values, { setSubmitting }) => {
                        const formattedData = {
                          id: values.id,
                          clientStandardHomePreferenceAnswerId: values.clientStandardHomePreferenceAnswerId,
                          clientId: parseInt(localStorage.getItem("userId")),
                          agentId: parseInt(localStorage.getItem("agentId")),
                          clientGuid: clientDetail?.clientId || "",
                          showingId: addListing?.id || 0,
                          clientStandardHomePreferenceId: 0,
                          typeOfHouse: values.listingType,
                          minPrice: parseInt(values.listedPrice),
                          maxPrice: parseInt(values.listedPrice),
                          sqFeets: values.sqFeets,
                          bedRoom: values.listingBedroom,
                          bathRoom: values.listingBathroom,
                          city: values.listingCity,
                          preferenceDescription: "",
                          whatYouLike: values.whatYouLike,
                          whatYouDislike: values.whatYouDislike,
                          createClientAdditionalHomePreferenceAnswers: values?.createClientAdditionalHomePreferenceAnswers.map((item) => ({
                            id: item.id || 0,
                            clientAdditionalHomePreferenceAnswerId: item.clientAdditionalHomePreferenceAnswerId || "00000000-0000-0000-0000-000000000000",
                            clientId: parseInt(localStorage.getItem("userId")),
                            agentId: parseInt(localStorage.getItem("agentId")),
                            clientGuid: clientDetail?.clientId || "",
                            showingId: addListing?.id || 0,
                            clientAdditionalHomePreferenceId: item.clientAdditionalHomePreferenceId,
                            clientAdditionalHomePreferenceAnswerTitle: item.clientAdditionalHomePreferenceAnswerTitle,
                            clientAdditionalHomePreferenceAnswerResponse: item.clientAdditionalHomePreferenceAnswerResponse,
                          })),
                        };
                        try {
                          toast.loading("please wait...");
                          const obj = JSON.parse(localStorage.getItem("authUser"));
                          const token = obj?.resultData?.bearerToken;
                          const headers = {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                          };
                          const response = await axios.post(`${API_URL}ClientAdditionalHomePreferenceAnswer/CreateClientAdditionalHomePreferenceAnswerWithStandard`, formattedData, { headers });
                          if (response.status === 200 || response.status === 201) {
                            toast.dismiss();
                            toast.success("Saved successfully")
                            this.manageToggle();
                          }
                        } catch (error) {
                          console.error("Submission Error:", error);
                        } finally {
                          setSubmitting(false);
                        }
                      }}
                    >
                      {({ values, errors, touched, handleChange, setFieldValue }) => (
                        <Form className="needs-validation">
                          <Row>
                            <Col sm="4">
                              <FormGroup className="mb-3">
                                <Label htmlFor="listingType">Type</Label>
                                <Field
                                  as="select"
                                  name="listingType"
                                  className={`form-control${errors.listingType && touched.listingType ? " is-invalid" : ""}`}
                                  onChange={handleChange}
                                >
                                  <option value="">Select</option>
                                  {map(listingtypes, (listingtype, key) => (
                                    <option key={key} value={listingtype.listingTypeTitle}>
                                      {listingtype.listingTypeTitle}
                                    </option>
                                  ))}
                                </Field>
                                <ErrorMessage name="listingType" component="div" className="invalid-feedback" />
                              </FormGroup>
                            </Col>
                            <Col sm="4">
                              <FormGroup className="mb-3">
                                <Label htmlFor="listedPrice">Price</Label>
                                <CurrencyInput
                                  id={`listedPrice`}
                                  name={`listedPrice`}
                                  className="form-control"
                                  value={values.listedPrice}
                                  prefix={userdetail?.agentDefaultCurrencyCode + " "}
                                  decimalsLimit={2}
                                  onValueChange={(value) => {
                                    setFieldValue(`listedPrice`, value);
                                  }}
                                />
                                {/* <Field
                                  name="listedPrice"
                                  type="text"
                                  className={`form-control${errors.listedPrice && touched.listedPrice ? " is-invalid" : ""}`}
                                  onChange={handleChange}
                                /> */}
                                <ErrorMessage name="listedPrice" component="div" className="invalid-feedback" />
                              </FormGroup>
                            </Col>
                            <Col sm="4">
                              <FormGroup className="mb-3">
                                <Label htmlFor="listingCity">City</Label>
                                <Field
                                  name="listingCity"
                                  type="text"
                                  className={`form-control${errors.listingCity && touched.listingCity ? " is-invalid" : ""}`}
                                  onChange={handleChange}
                                />
                                <ErrorMessage name="listingCity" component="div" className="invalid-feedback" />
                              </FormGroup>
                            </Col>
                            <Col sm="4">
                              <FormGroup className="mb-3">
                                <Label htmlFor="listingBedroom">Bedroom</Label>
                                <Field
                                  name="listingBedroom"
                                  type="text"
                                  className={`form-control${errors.listingBedroom && touched.listingBedroom ? " is-invalid" : ""}`}
                                  onChange={handleChange}
                                />
                                <ErrorMessage name="listingBedroom" component="div" className="invalid-feedback" />
                              </FormGroup>
                            </Col>
                            <Col sm="4">
                              <FormGroup className="mb-3">
                                <Label htmlFor="listingBathroom">Bathroom</Label>
                                <Field
                                  name="listingBathroom"
                                  type="text"
                                  className={`form-control${errors.listingBathroom && touched.listingBathroom ? " is-invalid" : ""}`}
                                  onChange={handleChange}
                                />
                                <ErrorMessage name="listingBathroom" component="div" className="invalid-feedback" />
                              </FormGroup>
                            </Col>
                            <Col sm="4">
                              <FormGroup className="mb-3">
                                <Label htmlFor="sqFeets">Square Feet</Label>
                                <Field
                                  name="sqFeets"
                                  type="text"
                                  className={`form-control${errors.sqFeets && touched.sqFeets ? " is-invalid" : ""}`}
                                  onChange={handleChange}
                                />
                                <ErrorMessage name="sqFeets" component="div" className="invalid-feedback" />
                              </FormGroup>
                            </Col>
                            <Col sm="12">
                              <h4>Select which of your features this property has</h4>
                            </Col>
                            {values.createClientAdditionalHomePreferenceAnswers.map((item, index) => (
                              <Col md="12" key={index}>
                                <FormGroup className="mb-3">
                                  <Field
                                    name={`createClientAdditionalHomePreferenceAnswers.${index}.clientAdditionalHomePreferenceAnswerResponse`}
                                    type="checkbox"
                                    className="form-check-input me-2"
                                    checked={item.clientAdditionalHomePreferenceAnswerResponse === "Yes"}
                                    onChange={() =>
                                      setFieldValue(
                                        `createClientAdditionalHomePreferenceAnswers.${index}.clientAdditionalHomePreferenceAnswerResponse`,
                                        item.clientAdditionalHomePreferenceAnswerResponse === "Yes" ? "No" : "Yes"
                                      )
                                    }
                                  />
                                  <Label htmlFor={`task_${index}`} className="form-check-label">
                                    {item.clientAdditionalHomePreferenceAnswerTitle}
                                  </Label>
                                </FormGroup>
                              </Col>
                            ))}
                            <Col sm="12">
                              <FormGroup className="mb-3">
                                <h4 htmlFor="whatYouLike">What I liked</h4>
                                <Field
                                  name="whatYouLike"
                                  as="textarea"
                                  style={{ minHeight: "100px" }}
                                  className={`form-control${errors.whatYouLike && touched.whatYouLike ? " is-invalid" : ""}`}
                                  onChange={handleChange}
                                />
                                <ErrorMessage name="whatYouLike" component="div" className="invalid-feedback" />
                              </FormGroup>
                            </Col>
                            <Col sm="12">
                              <FormGroup className="mb-3">
                                <h4 htmlFor="whatYouDislike">What I did not like</h4>
                                <Field
                                  name="whatYouDislike"
                                  as="textarea"
                                  style={{ minHeight: "100px" }}
                                  className={`form-control${errors.whatYouDislike && touched.whatYouDislike ? " is-invalid" : ""}`}
                                  onChange={handleChange}
                                />
                                <ErrorMessage name="whatYouDislike" component="div" className="invalid-feedback" />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <div className="clearFix">
                              <button type="submit" className="btn btn-primary">
                                Save
                              </button>{" "}
                              <RsLink iconClass="" onClick={this.toggleRightCanvas}>Cancel</RsLink>
                            </div>
                          </Row>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </TabPane>
                <TabPane tabId="3">
                  <div className="tabContent">
                    <Formik
                      enableReinitialize={true}
                      initialValues={{
                        clientPotentialListingMessageBy: clientDetail?.firstName,
                        clientPotentialListingId: addListing?.id,
                        scheduleDate: new Date(),
                        notes: "",
                      }}
                      validationSchema={Yup.object().shape({
                        notes: Yup.string().required("This is Required"),
                      })}
                      onSubmit={this.handleSubmitMessage}
                    >
                      {({ errors, touched, values, handleChange, setFieldValue }) => (
                        <Form
                          className="needs-validation"
                        >
                          <Row>
                            <Col sm="12">
                              <FormGroup className="mb-3">
                                <Label htmlFor="notes" className="w-100">
                                  {this.props.t("Enter your message")}
                                  <span className="float-end"> <AiButton onInsert={(text) => this.handleInsertAi(text, setFieldValue)} /> </span>
                                </Label>
                                <Field
                                  name="notes"
                                  onChange={handleChange}
                                  as="textarea"
                                  className={
                                    "form-control" +
                                    (errors.notes && touched.notes
                                      ? " is-invalid"
                                      : "")
                                  }
                                  id="mls"
                                />
                                <ErrorMessage
                                  name="notes"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <div className="clearFix">
                              <button type="submit" className="btn btn-primary w-md  mt20" name="addActivity" id="addActivity"> {this.props.t("Send")}</button>{" "}
                            </div>
                          </Row>
                        </Form>
                      )}
                    </Formik>
                    <div style={{ marginTop: 40 }}>
                      <Table className="table table-sm m-0">
                        <ul className="verti-timeline list-unstyled">
                          {messageData?.map((message, index) => (
                            <li className="event-list eventlist" key={`_allact_${index}`}>
                              <div className="event-timeline-dot">
                              </div>
                              <div className="d-flex">
                                <div className="flex-grow-1">
                                  <h5 className="font-size-14">
                                    {message.clientPotentialListingMessageBy || ''} -  <Moment format="MMM Do">{message.scheduleDate}</Moment>
                                  </h5>
                                </div>
                              </div>
                              <div className="exNote">{message.notes}</div>
                            </li>
                          ))}
                        </ul>
                      </Table>
                    </div>
                  </div>
                </TabPane>
                <TabPane tabId="4">
                  <div className="tabContent">
                    <Dropzone onDrop={this.handleAcceptedFiles}>
                      {({ getRootProps, getInputProps }) => (
                        <div className="dropzone">
                          <div className="dz-message needsclick" {...getRootProps()}>
                            <input {...getInputProps()} />
                            <div className="mb-3">
                              <i className="display-4 text-muted bx bxs-cloud-upload" />
                            </div>
                            <h4>Drop files here or click to upload.</h4>
                          </div>
                        </div>
                      )}
                    </Dropzone>
                    <Row className="mb-3" style={{ marginTop: 20 }}>
                      {imagesData?.map((img, index) => (
                        <Col sm="6" key={index}>
                          <div className="image-thumbnail-wrapper">
                            <img
                              src={img.clientPotentialListingImageLink}
                              className="thumbnail-img"
                              alt={`thumbnail-${index}`}
                              onClick={() => this.handleOpenLightbox(index)}
                              style={{ cursor: "pointer" }}
                            />
                            <button
                              className="delete-btn"
                              onClick={() => this.handleDeleteImage(img.id, index)}
                            >
                              &times;
                            </button>
                          </div>
                        </Col>
                      ))}
                    </Row>
                    {lightboxOpen && (
                      <Lightbox
                        mainSrc={imageUrls[photoIndex]}
                        nextSrc={imageUrls[(photoIndex + 1) % imageUrls.length]}
                        prevSrc={imageUrls[(photoIndex + imageUrls.length - 1) % imageUrls.length]}
                        onCloseRequest={() => this.setState({ lightboxOpen: false })}
                        onMovePrevRequest={() =>
                          this.setState({
                            photoIndex: (photoIndex + imageUrls.length - 1) % imageUrls.length,
                          })
                        }
                        onMoveNextRequest={() =>
                          this.setState({
                            photoIndex: (photoIndex + 1) % imageUrls.length,
                          })
                        }
                      />
                    )}
                  </div>
                </TabPane>
                <TabPane tabId="5">
                  <div className="tabContent">
                    <Formik
                      enableReinitialize={true}
                      initialValues={{
                        id: addListing?.id,
                        clientPotentialListingId: addListing?.clientPotentialListingId,
                        clientId: localStorage.getItem("userId"),
                        agentId: addListing?.agentId,
                        notes: addListing?.notes,
                        showingDate: addListing?.showingDate,
                        startTime: addListing?.startTime,
                        endTime: addListing?.endTime,
                        showingStatus: "Request Re-schedule",
                        showingStatusId: 2,
                        clientNotes: addListing?.clientNotes || ''
                      }}
                      validationSchema={Yup.object().shape({
                        //showingDate: Yup.string().required("This is Required"),
                        clientNotes: Yup.string().required("This is Required"),
                      })}
                      onSubmit={this.handleSubmitResuchedule}
                    >
                      {({ errors, touched, values, handleChange, setFieldValue, setFieldTouched }) => (
                        <Form
                          className="needs-validation"
                        >
                          <Row>
                            <Col sm="12"><h5>Request Re-schedule</h5></Col>
                            {/* {addListing.showingStatus=='Scheduled' ?   
                                  <>
                                            <Col sm="4">
                                               <FormGroup className="mb-3">
                                                         <Label htmlFor="showingDate">
                                                           {this.props.t("Schedule Date ")}
                                                         </Label>
                                                            <Flatpickr
                                                              className={
                                                                "form-control" +
                                                                (errors.showingDate && touched.showingDate
                                                                  ? " is-invalid"
                                                                  : "")
                                                              }
                                                              placeholder=""
                                                              value={values.showingDate}
                                                              onChange={(value) => setFieldValue('showingDate', value[0])}
                                                              options={{
                                                                altInput: true,
                                                                //minDate: "today",
                                                                altFormat: "F j, Y",
                                                                dateFormat: "Y-m-d"
                                                              }}
                                                            />
                                                     
                                                         
                       
                                                       </FormGroup>
                                               </Col>
                                               <Col sm="4">
                                                <TimePicker
                                                    name="startTime"
                                                    label="Start Time *"
                                                    value={values.startTime}
                                                    onChange={(val) => setFieldValue("startTime", val)}
                                                    onBlur={() => setFieldTouched("startTime", true)}
                                                    minTime={null}
                                                    error={errors.startTime}
                                                    touched={touched.startTime}
                                                  />
                                           
                                               </Col>
                                                <Col md="4">
                                                  <TimePicker
                          name="endTime"
                          label="End Time "
                          value={values.endTime}
                          onChange={(val) => setFieldValue("endTime", val)}
                          onBlur={() => setFieldTouched("endTime", true)}
                          minTime={values.startTime}
                          disabled={!values.startTime}
                          error={errors.endTime}
                          touched={touched.endTime}
                        />
                                                  
                                                  </Col> 
                                  </>
                                 : '' } */}
                            <Col sm="12">
                              <FormGroup className="mb-3">
                                <Label htmlFor="clientNotes">
                                  {this.props.t("Add Note")}
                                </Label>
                                <Field
                                  name="clientNotes"
                                  onChange={handleChange}
                                  as="textarea"
                                  className={
                                    "form-control" +
                                    (errors.clientNotes && touched.clientNotes
                                      ? " is-invalid"
                                      : "")
                                  }
                                  id="mls"
                                />
                                <ErrorMessage
                                  name="clientNotes"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <div className="clearFix">
                              {addListing.showingStatus == 'Scheduled' ?
                                <button type="submit" className="btn btn-primary w-md  mt20" name="addActivity" id="addActivity"> {this.props.t("Submit")}</button>
                                : <Alert color="danger">No showing schedule set for this listing.</Alert>}
                            </div>
                            {addListing?.showingDate != null && addListing.showingStatus == 'Scheduled' && (
                              <>
                                <Row>
                                  <Col sm="12">
                                    <h4 className="font-size-14 mt-4"><strong>Current Showing</strong></h4>
                                    <ul className="verti-timeline list-unstyled">
                                      <li className="event-list eventlist">
                                        <div className="">
                                          <div className="flex-shrink-0 me-3">
                                            <h5 className="font-size-14">
                                              Date : <Moment format="D MMM YY">{addListing?.showingDate}</Moment>
                                            </h5>
                                          </div>
                                          <div className="flex-grow-1">
                                            <h5 className="font-size-14">
                                              Time : {addListing?.startTime} - {addListing?.endTime}
                                            </h5>
                                          </div>
                                        </div>
                                        <div className="exNote">Notes: {addListing?.notes}</div>
                                      </li>
                                    </ul>
                                  </Col>
                                </Row>
                                <Row>
                                  <Row>
                                    <Col sm="12">
                                      <h4 className="font-size-14 mt-4"><strong>Showing history</strong></h4>
                                      <ul className="verti-timeline list-unstyled">
                                        {Array.isArray(schedules) && schedules.map((schedule, index) => (
                                          <li className="event-list eventlist" key={index}>
                                            <div className="">
                                              <div className="flex-shrink-0 me-3">
                                                <h5 className="font-size-14">
                                                  Date : <Moment format="D MMM YY">{schedule.showingDate}</Moment>
                                                </h5>
                                              </div>
                                              <div className="flex-grow-1">
                                                <h5 className="font-size-14">
                                                  Time : {schedule.startTime} - {schedule.endTime}
                                                </h5>
                                              </div>
                                            </div>
                                            <div className="exNote">Notes: {schedule.notes}</div>
                                          </li>
                                        ))}
                                      </ul>
                                    </Col>
                                  </Row>
                                </Row>
                              </>
                            )}
                          </Row>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </TabPane>
              </TabContent>
            </OffcanvasBody>
          </Offcanvas>
          <Offcanvas
            isOpen={this.state.isRoute}
            direction="end"
            toggle={this.toggleCreateRoute}
            style={{ width: 800 }}
          >
            <OffcanvasHeader toggle={this.toggleCreateRoute}>
              View Route
            </OffcanvasHeader>
            <OffcanvasBody>
              {/* <Formik
                  enableReinitialize={true}
                  initialValues={{
                    AgentId:localStorage.getItem('agentId'),
                    ClientId:localStorage.getItem('userId'),
                    forDate: "",
                    
                   
                  }}
                  validationSchema={Yup.object().shape({
                    forDate: Yup.string().required("This is Required"),
                  })}
                  onSubmit=""
                >
                  {({ errors, touched, values, handleChange, setFieldValue }) => (
                    <Form
                      className="needs-validation"
                    >
                      <Row>
                        <Col sm="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="forDate">
                              {this.props.t("Date")}
                            </Label>
                            <InputGroup>
                              <Flatpickr
                                name="showingDate"
                                className={
                                  "form-control" +
                                  (errors.forDate && touched.forDate
                                    ? " is-invalid"
                                    : "")
                                }
                                placeholder=""
                                value={values.forDate}
                                onChange={this.handleDateChange}
                                options={{
                                  altInput: true,
                                  altFormat: "F j, Y",
                                  dateFormat: "Y-m-d"
                                }}
                              />
                            </InputGroup>
                          </FormGroup>
                        </Col>
                       
                      </Row>
                    
                    </Form>
                  )}
                     </Formik> */}
              {this.state.routeData && this.state.routeData.length > 0 ? (
                <div className="accordion" id="accordion">
                  {this.state.routeData?.map((route, index) => (
                    <div className="accordion-item" key={index}>
                      <h2 className="accordion-header" id={`heading${index}`}>
                        <button
                          className={`accordion-button fw-medium ${this.state[`col${index}`] ? "" : "collapsed"}`}
                          type="button"
                          onClick={() => this.toggleCollapse(index)}
                          style={{ cursor: "pointer" }}
                        >
                          {route.forDate ? (
                            <>
                              <Moment format="MMM DD YYYY">{route.forDate}</Moment>
                              {route.forTime && (
                                <>
                                  &nbsp;{" @ "}&nbsp;
                                  {route.forTime}
                                </>
                              )}
                            </>
                          ) : (
                            "No Date"
                          )}
                        </button>
                      </h2>
                      <Collapse
                        isOpen={this.state[`col${index}`]}
                        className="accordion-collapse"
                      >
                        <div className="accordion-body">
                          <div className="text-muted">
                            <table className="align-middle mb-0 table">
                              <thead>
                                <tr>
                                  <th>Order</th>
                                  <th>MLS#</th>
                                  <th>Address</th>
                                  <th>Time</th>
                                </tr>
                              </thead>
                              <tbody>
                                {route.clientPotentialListingsShowingRouteItems?.map((item, idx) => (
                                  <tr key={idx}>
                                    <td>{item.routeOrder}</td>
                                    <td>{item?.listing?.mlsId}</td>
                                    <td>{item?.listing?.listingAddress}</td>
                                    <td>{item?.listing?.startTime + "-" + item?.listing?.endTime}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Collapse>
                    </div>
                  ))}
                </div>
              ) : (
                <Alert color="danger">No routes currently set</Alert>
              )}
            </OffcanvasBody>
          </Offcanvas>
              <Offcanvas
            isOpen={this.state.isFav}
            direction="end"
            toggle={this.toggleViewFav}
            style={{ width: 900 }}
          >
            <OffcanvasHeader toggle={this.toggleViewFav}>
              View Favourites
            </OffcanvasHeader>
              <OffcanvasBody>
                <div className="table-responsive">
                          <table className="table mb-0 table">
                            <thead>
                              <tr>
                                
                                <th>Date</th>
                                <th>Unit ID</th>
                                <th>Asking price</th>
                                <th className="hide-city-col">Address</th>
                                
                                
                                
                              </tr>
                            </thead>
                            <tbody>
                              {map(this.state.favourites, (addListing, lkey) => (
                                <tr key={"_alist_" + lkey}>
                                  
                                  <td><Moment format="DD MMM, YYYY">{addListing.listingDate}</Moment></td>
                                  <td><a target="_blank" rel="noreferrer" href={addListing.mlsurl}>{addListing.mlsId} <i className=" bx bx-link-external"></i></a></td>
                                  <td><CurrencyFormat value={addListing.listedPrice} displayType={'text'} thousandSeparator={true} prefix={userdetail?.agentDefaultCurrencyCode + " "} />
                                  </td>
                                  <td className="hide-city-col">{addListing.listingAddress} {addListing.listingCity} 
                                   
                                    
                                    </td>
                                  
                                  
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
              </OffcanvasBody>
          </Offcanvas>
          <Offcanvas
            isOpen={this.state.isPref}
            direction="end"
            toggle={this.togglePrefrences}
            style={{ width: 950 }}
          >
            <OffcanvasHeader toggle={this.togglePrefrences}>
              Set your preferences
            </OffcanvasHeader>
            <OffcanvasBody>
              <Nav pills className="navtab-bg">
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      active: this.state.activeTab3 === "1",
                    })}
                    onClick={() => {
                      this.toggle3("1");
                    }}
                  >
                    Home preferences
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      active: this.state.activeTab3 === "5",
                    })}
                    onClick={() => {
                      this.toggle3("5");
                    }}
                  >
                    Important destinations
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent
                activeTab={this.state.activeTab3}
                className="p-3 text-muted"
              >
                <TabPane tabId="1">
                  <Alert color="" role="alert" style={{ fontSize: 15, color: '#000', border: '1px solid #ccc', borderRadius: 12, background:'#fbfdb8' }}>
                    <i className=" bx bxs-check-circle" style={{ color: '#3FB93B', verticalAlign: 'middle', fontSize: 28 }}></i> These preferences are visible to your agent, so they can help you find the perfect home.
                  </Alert>
                  <h5 className="card-title mb-3">Set standard preferences</h5>
                  <Formik
                    enableReinitialize={true}
                    initialValues={{
                      id: homeprefrences?.id || 0,
                      clientStandardHomePreferenceId: homeprefrences?.clientStandardHomePreferenceId || '0580dbc4-463f-4570-99b9-7fbccd84756d',
                      typeOfHouse: homeprefrences?.typeOfHouse,
                      minPrice: homeprefrences?.minPrice || "",
                      maxPrice: homeprefrences?.minPrice || "",
                      sqFeets: homeprefrences?.sqFeets || "",
                      bedRoom: homeprefrences?.bedRoom || "",
                      bathRoom: homeprefrences?.bathRoom || "",
                      city: homeprefrences?.city || "",
                      preferenceDescription: homeprefrences?.preferenceDescription || "",
                      clientId: localStorage.getItem('userId'),
                      clientGuid: clientDetail?.clientId
                    }}
                    validationSchema={Yup.object().shape({
                      typeOfHouse: Yup.string().required("This is Required"),
                      // minPrice: Yup.number()
                      //   .transform((value, originalValue) => (originalValue === "" ? null : value))
                      //   .typeError("Must be a number")
                      //   .integer("Must be an integer")
                      //   .required("This field is required"),
                      // maxPrice: Yup.number()
                      //   .transform((value, originalValue) => (originalValue === "" ? null : value))
                      //   .typeError("Must be a number")
                      //   .integer("Must be an integer")
                      //   .required("This field is required"),
                      sqFeets: Yup.number()
                        .transform((value, originalValue) => (originalValue === "" ? null : value))
                        .typeError("Must be a number")
                        .integer("Must be an integer")
                        .required("This field is required"),
                    })}
                    onSubmit={this.handleHomePrefSubmit}
                  >
                    {({ errors, touched, values, handleChange, setFieldValue }) => (
                      <Form
                        className="needs-validation"
                      >
                        <Row>
                          <Col sm="6">
                            <FormGroup className="mb-3">
                              <Label htmlFor="typeOfHouse">
                                {this.props.t("Type of property")}
                              </Label>
                              <Field as="select" name="typeOfHouse"
                                className={
                                  "form-control" +
                                  (errors.typeOfHouse && touched.typeOfHouse
                                    ? " is-invalid"
                                    : "")
                                }
                                onChange={handleChange}>
                                <option value="">Select</option>
                                <option value="Apartment">Apartment</option>
                                <option value="Condominium">Condominium</option>
                                <option value="Detached">Detached</option>
                                <option value="Semi-detached">Semi-detached</option>
                                <option value="Townhouse">Townhouse</option>
                              </Field>
                              <ErrorMessage
                                name="typeOfHouse"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>
                          </Col>
                          <Col sm="2">
                            <FormGroup className="mb-3">
                              <Label htmlFor="bedRoom">
                                {this.props.t("# Room")}
                              </Label>
                              <Field
                                name="bedRoom"
                                onChange={handleChange}
                                type="text"
                                className={
                                  "form-control" +
                                  (errors.bedRoom && touched.bedRoom
                                    ? " is-invalid"
                                    : "")
                                }
                                id="mls"
                              />
                              <ErrorMessage
                                name="bedRoom"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>
                          </Col>
                          <Col sm="2">
                            <FormGroup className="mb-3">
                              <Label htmlFor="bathRoom">
                                {this.props.t("# Bath")}
                              </Label>
                              <Field
                                name="bathRoom"
                                onChange={handleChange}
                                type="text"
                                className={
                                  "form-control" +
                                  (errors.bathRoom && touched.bathRoom
                                    ? " is-invalid"
                                    : "")
                                }
                                id="mls"
                              />
                              <ErrorMessage
                                name="bathRoom"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>
                          </Col>
                          <Col sm="2">
                            <FormGroup className="mb-3">
                              <Label htmlFor="listingParking">
                                {this.props.t("Parking")}
                              </Label>
                              <Field
                                name="listingParking"
                                onChange={handleChange}
                                type="text"
                                className={
                                  "form-control" +
                                  (errors.listingParking && touched.listingParking
                                    ? " is-invalid"
                                    : "")
                                }
                                id="mls"
                              />
                              <ErrorMessage
                                name="listingParking"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>
                          </Col>
                          <Col sm="6">
                            <FormGroup className="mb-3">
                              <Label htmlFor="city">
                                {this.props.t("Cities of interest ( comma separed)")}
                              </Label>
                              <Field
                                name="city"
                                onChange={handleChange}
                                type="text"
                                className={
                                  "form-control" +
                                  (errors.city && touched.city
                                    ? " is-invalid"
                                    : "")
                                }
                                id="mls"
                              />
                              <ErrorMessage
                                name="city"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>
                          </Col>
                          <Col sm="2">
                            <FormGroup className="mb-3">
                              <Label htmlFor="sqFeets">
                                {this.props.t("Size")}
                              </Label>
                              <Field
                                name="sqFeets"
                                onChange={handleChange}
                                type="text"
                                className={
                                  "form-control" +
                                  (errors.sqFeets && touched.sqFeets
                                    ? " is-invalid"
                                    : "")
                                }
                                id="mls"
                              />
                              <ErrorMessage
                                name="sqFeets"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>
                          </Col>
                          <Col sm="2">
                            <FormGroup className="mb-3">
                              <Label htmlFor="minPrice">
                                {this.props.t("Min. price")}
                              </Label>
                              {/* <Field
                              name="minPrice"
                              onChange={handleChange}
                              type="text"
                              className={
                                "form-control" +
                                (errors.minPrice && touched.minPrice
                                  ? " is-invalid"
                                  : "")
                              }
                              id="minPrice"
                            /> */}
                              <CurrencyInput
                                id={`minPrice`}
                                name={`minPrice`}
                                className="form-control"
                                value={values.minPrice}
                                prefix={userdetail?.agentDefaultCurrencyCode + " "}
                                decimalsLimit={2}
                                onValueChange={(value) => {
                                  setFieldValue(`minPrice`, value);
                                }}
                              />
                              <ErrorMessage
                                name="minPrice"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>
                          </Col>
                          <Col sm="2">
                            <FormGroup className="mb-3">
                              <Label htmlFor="maxPrice">
                                {this.props.t("Max price")}
                              </Label>
                              <CurrencyInput
                                id={`maxPrice`}
                                name={`maxPrice`}
                                className="form-control"
                                prefix={userdetail?.agentDefaultCurrencyCode + " "}
                                decimalsLimit={2}
                                value={values.maxPrice}
                                onValueChange={(value) => {
                                  setFieldValue(`maxPrice`, value);
                                }}
                              />
                              {/* <Field
                              name="maxPrice"
                              onChange={handleChange}
                              type="text"
                              className={
                                "form-control" +
                                (errors.maxPrice && touched.maxPrice
                                  ? " is-invalid"
                                  : "")
                              }
                              id="mls"
                            /> */}
                              <ErrorMessage
                                name="maxPrice"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>
                          </Col>
                          <Col sm="12">  <div className="clearfix"><button style={{ marginTop: 10 }} type="submit" className="btn btn-primary w-sm">Save</button></div></Col>
                        </Row>
                      </Form>
                    )}
                  </Formik>
                  <h5 className="card-title mb-2 mt-20">Set your specific preferences</h5>
                  <p style={{ fontSize: 14, marginTop: 20, marginBottom: 0 }}>
                    List any features you’d like to have or avoid, and mark them as ‘Must Have’ or ‘Nice to Have’ to guide your agent’s search.</p>
                  <p style={{ fontSize: 14, marginBottom: 0 }}>Example  : </p>
                  <ul>
                    <li style={{ fontSize: 14 }}>Close to a highway OR Not close to a highway</li>
                    <li style={{ fontSize: 14 }}>Open concept kitchen</li>
                  </ul>
                  <Formik
                    enableReinitialize={true}
                    initialValues={{
                      clientId: localStorage.getItem('userId'),
                      clientGuid: clientDetail?.clientId,
                      clientAdditionalHomePreferenceTitle: "",
                      clientAdditionalHomePreferenceDescription: "Must Have",
                      clientAdditionalHomePreferenceIsActive: true
                    }}
                    validationSchema={Yup.object().shape({
                      clientAdditionalHomePreferenceTitle: Yup.string().required("This is Required"),
                    })}
                    onSubmit={this.submitAddHomePrefData}
                  >
                    {({ errors, touched, values, handleChange, setFieldValue }) => (
                      <Form
                        className="needs-validation"
                      >
                        <Row>
                          <Col sm="6">
                            <FormGroup className="mb-3">
                              <Label htmlFor="clientAdditionalHomePreferenceTitle">
                                {this.props.t("Name the preference *")}
                              </Label>
                              <Field
                                name="clientAdditionalHomePreferenceTitle"
                                type="text"
                                onChange={handleChange}
                                className={
                                  "form-control" +
                                  (errors.clientAdditionalHomePreferenceTitle && touched.clientAdditionalHomePreferenceTitle
                                    ? " is-invalid"
                                    : "")
                                }
                                id="clientAdditionalHomePreferenceTitle"
                              />
                              <ErrorMessage
                                name="clientAdditionalHomePreferenceTitle"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>
                          </Col>
                          <Col sm="4">
                            <div className="btn-group" role="group" style={{ marginTop: 27 }}>
                              <Field type="radio" className="btn-check" name="clientAdditionalHomePreferenceDescription" id="btnradio4" autoComplete="off" value="Must Have" />
                              <label className="btn btn-outline-secondary" htmlFor="btnradio4">Must Have</label>
                              <Field type="radio" className="btn-check" name="clientAdditionalHomePreferenceDescription" id="btnradio5" value="Nice to Have" autoComplete="off" />
                              <label className="btn btn-outline-secondary" htmlFor="btnradio5">Nice to Have</label>
                            </div>
                          </Col>
                          <Col sm="2">  <div className="clearfix"><button type="submit" className="saveCircle" style={{ marginTop: 25 }}><i className="bx bx-save" /></button></div></Col>
                        </Row>
                      </Form>
                    )}
                  </Formik>
                  <table className="table">
                    <tbody>
                      {addprefrences && addprefrences.length > 0 ? (
                        addprefrences.map((preference, index) => (
                          <tr key={index}>
                            <td>{preference.clientAdditionalHomePreferenceDisplay}</td>
                            <td>
                              <div className="d-flex gap-3">
                                <img className='tab-img' style={{ cursor: 'pointer', width: 20, height: 20 }} src={deleteIcon} onClick={() => this.onClickDelete(preference)} />
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td style={{ textAlign: "center" }}>No preferences found</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </TabPane>
                <TabPane tabId="5">
                  <Alert color="" role="alert" style={{ fontSize: 15, color: '#000', border: '1px solid #ccc', borderRadius: 12, background:'#fbfdb8' }}>
                    <i className=" bx bxs-check-circle" style={{ color: '#3FB93B', verticalAlign: 'middle', fontSize: 28 }}></i>  These preferences are visible to your agent, so they can help you find the perfect home.
                  </Alert>
                  <Row>
                    <Col sm="12">
                      {/* <p style={{fontSize:14}}>
                                       <i className=" bx bxs-x-circle font-size-20" style={{verticalAlign:'middle', color:'#FF5C5C'}}></i> Please note, this information is not visible to your agent.
                                        </p> */}
                      <p style={{ fontSize: 14 }}>
                        The system will use these to calculate distance from each property you view, helping you compare locations and find the most convenient fit.
                      </p>
                      <Formik
                        enableReinitialize={true}
                        initialValues={{
                          clientId: parseInt(localStorage.getItem('userId')),
                          agentId: parseInt(localStorage.getItem('agentId')),
                          destinationTitle:  "",
                          destinationAddress:  "",
                          fullAddress: '',
                          addressLine1: '',
                          addressLine2: '',
                          city: '',
                          province: '',
                          postal: '',
                          country: '',
                          longitude: '',
                          latitude: '',
                          isValid: true,
                          isActive: true,
                        }}
                        validationSchema={Yup.object().shape({
                          destinationTitle: Yup.string().required("This is Required"),
                          destinationAddress: Yup.string().required("This is Required"),
                        })}
                        onSubmit={this.handleValidSubmit}
                      >
                        {({ errors, touched, values, handleChange, setFieldValue }) => (
                          <Form
                            className="needs-validation"
                          >
                            <Row>
                              <Col sm="4">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="destinationTitle">
                                    {this.props.t("Name of the destination")}
                                  </Label>
                                  <Field
                                    name="destinationTitle"
                                    onChange={handleChange}
                                    type="text"
                                    className={
                                      "form-control" +
                                      (errors.destinationTitle && touched.destinationTitle
                                        ? " is-invalid"
                                        : "")
                                    }
                                    id="destinationTitle"
                                  />
                                  <small>( e.g Office, Gym etc)</small>
                                  <ErrorMessage
                                    name="destinationTitle"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </FormGroup>
                              </Col>
                              <Col sm="6">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="destinationAddress">
                                    {this.props.t("Address of the destination")}
                                  </Label>
                                  <PlacesAutocomplete
                                    value={values.destinationAddress}
                                    onChange={(value) => setFieldValue(`destinationAddress`, value)}
                                    onSelect={(value) => this.handlePlaceSelectedDate(value, setFieldValue)}
                                  >
                                    {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                      <div>
                                        <input
                                          {...getInputProps({
                                            placeholder: 'Enter Address...',
                                            className: 'form-control',
                                          })}
                                        />
                                        <div className="">
                                          {loading ? <div>Loading...</div> : null}
                                          {suggestions.map((suggestion, i) => {
                                            const className = suggestion.active
                                              ? 'suggestion-item--active'
                                              : 'suggestion-item';
                                            const style = suggestion.active
                                              ? { backgroundColor: '#007BFF', color: '#fff', cursor: 'pointer', padding: '10px' }
                                              : { backgroundColor: '#fff', cursor: 'pointer', padding: '10px' };
                                            return (
                                              <div
                                                key={i}
                                                {...getSuggestionItemProps(suggestion, {
                                                  style,
                                                })}
                                              >
                                                {suggestion.description}
                                              </div>
                                            );
                                          })}
                                        </div>
                                      </div>
                                    )}
                                  </PlacesAutocomplete>
                                  <ErrorMessage
                                    name="destinationAddress"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </FormGroup>
                              </Col>
                              <Col sm="2">  <div className="clearfix"><button style={{ marginTop: 27 }} type="submit" className="btn btn-primary w-md">Add</button></div></Col>
                              <h5 className="card-title" style={{ marginTop: 20, marginBottom: 20 }}>Important Destinations History</h5>
                              <div className="table-responsive">
                                <table className="table mb-0 table">
                                  <thead>
                                    <tr>
                                      <th>Title</th>
                                      <th>Address</th>
                                      <th>Remove</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {map(impdestinations, (impdestination, appoint) => (
                                      <tr key={"_app_" + appoint}>
                                        <td>{impdestination.destinationTitle}</td>
                                        <td>{impdestination.destinationAddress}</td>
                                        <td>  <img className='tab-img' src={deleteIcon} onClick={() => this.onClickDelete(impdestination)} /></td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </Row>
                          </Form>
                        )}
                      </Formik>
                    </Col>
                  </Row>
                </TabPane>
              </TabContent>
            </OffcanvasBody>
          </Offcanvas>
        </div>
      </React.Fragment>
    )
  }
}
addListing.propTypes = {
  t: PropTypes.any,
  history: PropTypes.object,
  addClientAddListing: PropTypes.func,
  addListings: PropTypes.array,
  onGetClientAddListing: PropTypes.func,
  loading: PropTypes.object,
  listingtypes: PropTypes.array,
  onGetListingType: PropTypes.func,
  onGetAddHomePref: PropTypes.func,
  onGetClientDetail: PropTypes.func,
  clientDetail: PropTypes.object,
  addprefrences: PropTypes.array,
 
  userdetail: PropTypes.object,
  onGetUserDetail: PropTypes.func,
  postHomePref: PropTypes.func,
  onGetHomePref: PropTypes.func,
  homeprefrences: PropTypes.object,
  onDeleteHomePref: PropTypes.func,
  onUpdateHomePref: PropTypes.func,
  createAddHomePref: PropTypes.func,
  onUpdateAddPref: PropTypes.func,
  updateHomePref: PropTypes.func,
  postImpDestination: PropTypes.func,
  onGetImpDestination: PropTypes.func,
  impdestinations: PropTypes.array,
  onUpdateImpDestination: PropTypes.func,
  onDelete: PropTypes.func
}
const mapStateToProps = ({ addListing, AppoinmentObject, Profile, Prefrences, Login }) => (
  {
    clientDetail: Profile.clientDetail,
    addListings: addListing.addListings,
    loading: addListing.loading,
    listingtypes: AppoinmentObject.listingtypes,
    addprefrences: Prefrences.addprefrences,
    userdetail: Login.userdetail,
    homeprefrences: Prefrences.homeprefrences,
    impdestinations: Prefrences.impdestinations,
  })
const mapDispatchToProps = dispatch => ({
  onGetClientDetail: clientId => dispatch(getClientDetail(clientId)),
  addClientAddListing: (data, callback) => dispatch(addClientAddListing(data, callback)),
  onGetClientAddListing: (clientId, agentId) => dispatch(getClientAddListing(clientId, agentId)),
  onGetListingType: agentId => dispatch(getListingType(agentId)),
  onGetAddHomePref: clientId => dispatch(getAddHomePref(clientId)),
  onGetUserDetail: agentId => dispatch(getUserDetail(agentId)),
  postHomePref: (data, callback) => dispatch(postHomePref(data, callback)),
  onGetHomePref: (clientId) => dispatch(getHomePref(clientId)),
  updateHomePref: (data, callback) => dispatch(updateHomePref(data, callback)),
  createAddHomePref: (data) => dispatch(createAddHomePref(data)),
  onDeleteHomePref: (data) => dispatch(deleteHomePref(data)),
  onUpdateAddPref: (data) => dispatch(updateAddHomePref(data)),
  postImpDestination: (data, callback) => dispatch(postImpDestination(data, callback)),
  onGetImpDestination: (clientId, agentId) => dispatch(getImpDestination(clientId, agentId)),
  onUpdateImpDestination: (data) => dispatch(updateImpDestination(data)),
  onDelete: (data) => dispatch(deleteImpDestination(data))
});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(addListing))
